import { cx } from '@emotion/css';

import Icon from '../Button/Icon';
import {
  buttonClassName,
  buttonIconClassName,
  buttonTextClassName,
  contentClassName,
  mobileIconOnlyIconClassName,
  mobileIconOnlyTextClassName,
  subtleClassName,
  subtleIconClassName,
} from '../Button/styles';
import Text from '../Button/Text';
import Link from '../Link';

import { ButtonLinkProps } from './types';

type Props = ButtonLinkProps;

const ButtonLink = ({
  children,
  className = '',
  faIcon,
  iconAft,
  iconClassName = '',
  mobileIconOnly,
  subtle,
  svgIcon,
  textClassName = '',
  ...props
}: Props) => {
  return (
    <Link
      className={cx(buttonClassName, {
        [subtleClassName]: subtle,
        [className]: !!className,
      })}
      {...props}
    >
      <span data-test-id="button-content" className={contentClassName}>
        {!iconAft && (faIcon || svgIcon) && (
          <Icon
            className={cx(iconClassName, {
              [subtleIconClassName]: subtle,
              [mobileIconOnlyIconClassName]: mobileIconOnly,
            })}
            fa={faIcon}
            svg={svgIcon}
            pre={!!children}
          />
        )}
        {!!children && (
          <Text
            className={cx(buttonTextClassName, textClassName, {
              [mobileIconOnlyTextClassName]: mobileIconOnly,
            })}
          >
            {children}
          </Text>
        )}
        {iconAft && (
          <Icon
            className={cx(buttonIconClassName, iconClassName)}
            fa={faIcon}
            svg={svgIcon}
            aft
          />
        )}
      </span>
    </Link>
  );
};

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;
